import { React } from 'react';
import { Box, Typography } from "@mui/material";

const FormElements = {
  FormContainer: ({ children }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        mt: 2,
        gap: theme => theme.spacing(1.5), /* 12px */
        flex: '1 0 0',
        alignSelf: 'stretch',
      }}
    >
      {children}
    </Box>
  ),
  FormSection: ({ children }) => (
    <Box
      sx={{
        display: 'flex',
        // height: '855px',
        // width: '676px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme => theme.spacing(1), /* 8px */
      }}
    >
      {children}
    </Box>
  ),
  FormSubsection: ({ children }) => (
    <Box
      sx={{
        // display: 'flex',
        padding: 1,
        // flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme => theme.spacing(1), /* 12px */
        flexShrink: 0,
        alignSelf: 'stretch',
        borderRadius: theme => theme.spacing(.75), /* 6px */
        border: theme => `1px solid ${theme.palette.neutral[200]}`,
      }}
    >
      {children}
    </Box>
  ),
  FormRow: ({ children }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        alignSelf: 'stretch',
      }}
    >
      {children}
    </Box>
  ),
  SideBar: ({ height, children }) => (
    <Box
      sx={{
        // display: 'flex',
        height: height,
        // flexDirection: 'column',
        // justifyContent: 'center',
        alignItems: 'flex-start',
        padding: 2,
        gap: theme => theme.spacing(1.5), /* 12px */
        border: theme => `1px solid ${theme.palette.neutral[200]}`,
      }}
    >
      {children}
    </Box>
  ),
  SectionTitle: ({ title }) => (
    <Box
      sx={{
        background: theme => theme.palette.neutral[200],
        padding: 0.5,
        mt: 1,
        mb: 0,
      }}
    >
      <Typography variant='subtitle2' style={{
        color: theme => theme.palette.base.black,
        fontWeight: 600,
        textTransform: 'uppercase'
      }}>
        {title}
      </Typography>
    </Box>
  ),
  FormFooter: ({ children }) => (
    <Box
      sx={{
        display: 'flex',
        height: 80,
        pt: 2,
        pr: 4,
        pb: 3,
        pl: 3,
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 4,
        alignSelf: 'stretch',
        borderTop: '1px solid',
        borderColor: theme => theme.palette.neutral[200],
      }}
    >
      {children}
    </Box>
  ),
};

export default FormElements;